import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from '../auth/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router) {}

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot):
    boolean | Observable<boolean> | Promise<boolean> {
    const loggedUser = this.authService.getLoggedUser();

    if (!loggedUser) {
      this.router.navigate(['pages/home']);
      return false;
    }

    return true;
  }

}
